module.exports = __webpack_public_path__ + "img/appIcon2.5ff05a58.png";